import React from "react";
import RoleDashboard from "../components/RoleDashboard";

export default function Dashboard() {
  return <RoleDashboard heading="Dashboard" />;
}
